import React, { useState } from "react"
import { Link } from "react-router-dom";

import LayoutAuth from "../../components/layoutAuth";

import { authService } from "../../services/auth";
import { trackEvent } from "../../utils/tracking";
import { getParameterByName } from "../../utils/urls";


const Login = ({authenticated }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const submitForm = (e) => {
    e.preventDefault();  // to not post to the current url
    setLoading(true);

    authService.login(
      e.target.elements['email'].value,
      e.target.elements['password'].value,
      (response) => {
        setError(null);
        trackEvent('login', { method: 'email' });
        authService.fetchUser(() => {
          const next = getParameterByName('next', window.location);
          if (next){
            window.location = next;
          } else {
            window.location = '/'; // take user to home page
          }
        }, () => {
          console.error("Failed to fetch user info")
        });
        //setLoading(false);  // no need, wait for redirect
      },
      (error, response) => {
        setError(error && error.response && error.response.data.detail ? error.response.data.detail : 'could not log in');
        setLoading(false);
      }
    )
  }

  return (
    <LayoutAuth title="Sign in to your account" subtitle="Insights while you sleep.">
      <form className="space-y-6" action="#" onSubmit={submitForm}>

        {error ? (
          <div className="rounded-md p-4 border border-red-500 border-opacity-50 bg-red-500 bg-opacity-10">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-red-500">
                  {error}
                </h3>
              </div>
            </div>
          </div>
        ) : ''}

        <div>
          <label htmlFor="email" className="block text-sm font-medium text-theme-text">
            Email address
          </label>
          <div className="mt-1">
            <input 
              id="email" 
              name="email" 
              type="email" 
              autoComplete="email" 
              required 
              placeholder="you@example.com"
              className="appearance-none block w-full px-3 py-2 border border-theme-secondary rounded-md bg-theme-main shadow-sm text-theme-text placeholder-opacity-60 focus:outline-none focus:ring-theme-primary focus:border-theme-primary sm:text-sm"
            />
          </div>
        </div>

        <div>
          <label htmlFor="password" className="block text-sm font-medium text-theme-text">
            Password
          </label>
          <div className="mt-1">
            <input 
              id="password" 
              name="password" 
              type="password" 
              autoComplete="current-password" 
              required 
              placeholder="Enter your password"
              className="appearance-none block w-full px-3 py-2 border border-theme-secondary rounded-md bg-theme-main shadow-sm text-theme-text placeholder-opacity-60 focus:outline-none focus:ring-theme-primary focus:border-theme-primary sm:text-sm"
            />
          </div>
        </div>

        <div className="text-right text-sm">
          <Link to="/reset-password/" className="font-medium text-theme-primary hover:opacity-80">
            Forgot your password?
          </Link>
        </div>

        <div>
          <button type="submit" className="cursor-pointer w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-theme-button focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-theme-primary"
            disabled={loading}
            style={{
              backgroundColor: loading ? 'var(--theme-primary)' : 'var(--theme-primary)',
              opacity: loading ? 0.7 : 1,
            }}
            onMouseEnter={(e) => {
              if (!loading) {
                e.currentTarget.style.opacity = '0.9';
              }
            }}
            onMouseLeave={(e) => {
              if (!loading) {
                e.currentTarget.style.opacity = '1';
              }
            }}
          >
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </div>

        <div className="text-center text-sm">
          <span className="text-theme-text opacity-80">New to MoonScroll? </span>
          <Link to="/register/" className="font-medium text-theme-primary hover:opacity-80 underline">
            Click here to register
          </Link>
        </div>
      </form>
    </LayoutAuth>
  );
}

export default Login;
